import Network from './network';

export default {
  getAssetImport(assetImportId, params, callbacks) {
    const queryParams = `program_id=${params.programId}&program_type=${params.programType}`;
    return Network.get(`/asset_imports/${assetImportId}/show_as_json?${queryParams}`, callbacks);
  },
};
